import styled from 'styled-components'
import { ifProp } from 'styled-tools'
import { Alignment } from '../../styled'

export const Container = styled(Alignment)<{ alignment: string }>`
  justify-content: ${ifProp({ alignment: 'horizontal' }, 'center')};
`
